// Humanized order status translations
export default {
  offer_requested_by_buyer: 'Offer requested by buyer',
  no_response_from_seller: 'No response from seller',
  accepted_by_seller: 'Accepted by seller',
  accepted_by_seller_exception_by_shipper: 'Accepted by seller exception by shipper',
  shipped_by_seller: 'Shipped by seller',
  delivered_to_buyer: 'Delivered to buyer',
  not_accepted_by_seller: 'Offer declined by the seller',
  not_accepted_by_buyer: 'Offer cancelled by the buyer',
  failed_to_secure_buyer_funds: 'Failed buyer credit card authorization',
  failed_to_secure_buyer_funds_insufficient: 'Failed buyer credit card authorization. Insufficient funds.',
  buyer_updated_card_after_failure: 'Buyer updated credit card after a failure',
  shipping_rate_changed: 'Shipment failed, rate changed',
  could_not_be_shipped: 'Shipment failed (unknown)',
  delivery_exception: 'Shipment has a delivery exception',
  not_shipped_by_seller: 'Not shipped by seller on time',
  return_not_shipped_by_buyer: 'Return not shipped by the buyer on time',
  order_completed: 'Order completed',
  order_completed_with_error: 'Order completed, but final auth failed',
  order_return_requested: 'Return requested by buyer',
  order_return_shipped: 'Return shipped by buyer',
  order_return_delivered: 'Return has been delivered to the seller',
  order_flagged_as_fraud: 'Fraud',
  order_return_completed: 'Return completed',
};
